import { eDispatch } from '@/interface/eCommand';

export const dispatch_status_config: { [key: number]: string } = {
  [eDispatch.NO]: '不存在',
  [eDispatch.OPEN]: '已开机',
  [eDispatch.WAIT_OPEN]: '等开机',
  [eDispatch.DISPATCH]: '已调度',
  [eDispatch.WAIT_RESTART]: '等重启',
  [eDispatch.CLOSE]: '已关机',
  [eDispatch.WAIT_CLOSE]: '等关机',
};
